"use client";

import React from "react";

import { createSVGIcon } from "../util";

/** @optimized using svgo:^3.0.2 */
export const OutOfStock = createSVGIcon(
  <path
    d="M3.428 15.429H1.714a1.143 1.143 0 0 1-1.143-1.143V5.143h14.857v9.143a1.143 1.143 0 0 1-1.142 1.143H12.57M12.907 1.109a1.14 1.14 0 0 0-.969-.537H4.062a1.14 1.14 0 0 0-.97.537L.572 5.143h14.856zM5.6 8l4.848 4.849M5.6 12.849 10.448 8"
    stroke="#333"
    strokeLinecap="round"
    strokeLinejoin="round"
  />,
  "Out of Stock",
  { viewBox: "0 0 16 16", titleAccess: "Out of Stock", fill: "none" }
);
